import { FormFieldIcon, FormFieldSizeVariant } from "@insite/mobius/FormField";
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import { RadioStyle } from "@insite/mobius/Radio";
import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@store/theme/design";
import { buttonThemeStyles, StoreThemeButtonProps } from "@store/theme/mixins";
import { css, ThemeProps } from "styled-components";

// Original interface : ...\mobius\src\FormField\FormField.tsx
interface FormFieldStyleProps extends ThemeProps<BaseTheme> {
    _sizeVariant: FormFieldSizeVariant;
}

export const formInputStyles = () => {
    return css<FormFieldStyleProps>`
        vertical-align: top;

        + button {
            outline-offset: -${props => props.theme.focus?.width};
        }

        &:disabled {
            border-color: ${getColor("common.borderDark")};
            background-color: ${getColor("common.disabledLighter")} !important; /* Force over the datepicker selector */
            opacity: 1;

            + button ${FormFieldIcon} {
                background: transparent;
            }

            + ${IconWrapper} {
                background: transparent;
            }
        }

        ${({ _sizeVariant }) => {
            if (_sizeVariant) {
                return `
                    &:not([aria-describedby]):nth-last-child(2),
                    &[aria-describedby]:nth-last-child(3),
                    &[role="searchbox"] {
                        padding-right: ${sizeVariantValues[_sizeVariant].height - 2}px;
                    }
                `;
            }
        }};
    `;
};

export const formFieldButtonIconStyles = () => {
    return css`
        &:not(.override) {
            top: 0;
            left: 0;
            background-color: transparent;
            color: inherit;
            transform: scale(1.15);
        }
    `;
};

export const formFieldButtonIconClickableStyles = (themeButtonProps: StoreThemeButtonProps) => {
    return css`
        &:not(.override) {
            ${buttonThemeStyles(themeButtonProps)}
            transform: scale(0.85);
        }
    `;
};

export const formQuantityInputStyles = () => {
    return css`
        width: 45px;
        padding: 0.5em;
        text-align: center;
    `;
};

export const formHorizontalRadioGroupStyles = (spacing = "1em") => {
    return css`
        display: block;
        line-height: ${TYPOGRAPHY.lineHeight.smaller};
        ${RadioStyle} {
            display: inline-block;
            margin-right: ${spacing};

            &:last-child {
                margin-right: 0;
            }

            & + ${RadioStyle} {
                margin-top: 0;
            }
        }
    `;
};

export const formVerticalRadioGroupStyles = (spacing = "0.5em") => {
    return css`
        display: block;

        label {
            font-size: inherit;
        }

        ${RadioStyle} {
            margin-top: ${spacing};
            &:first-child {
                margin-top: 0;
            }
        }
    `;
};
